import { HttpHandler } from './HttpHandler';
import { environment } from '../enviroments';
import { TreeNode } from '@mindly/ui-components';
import { logDeviceInfo } from '../shared/utils/logDeviceInfo';

export const fetchLastContractBySpecialistId = async (specialistId: string) => {
  const { data } = await HttpHandler({
    method: 'GET',
    url: `${environment.CONTRACT_SPECIALIST_CLIENT_APP_URL}/clients-contracts/client/contract/last/${specialistId}`,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return data.data;
};

export const createSpecialistClientContractByClient = async (specialistId: string) => {
  const identificationData = await logDeviceInfo();
  const { data } = await HttpHandler({
    method: 'POST',
    url: `${environment.CONTRACT_SPECIALIST_CLIENT_APP_URL}/clients-contracts/client/${specialistId}`,
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      identificationData,
    },
  });

  return data?.data;
};

export const fetchSpecialistContractNewJsonTreeById = async (
  specialistId: string,
  lang: string
): Promise<TreeNode[]> => {
  const { data } = await HttpHandler({
    method: 'GET',
    url: `${environment.DOCUMENTS_APP_URL}/documents/pdf/client/clients-contracts/new-json-tree/${specialistId}/${lang}`,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return data.data;
};

export const fetchSpecialistContractJsonTreeById = async (specialistId: string, lang: string): Promise<TreeNode[]> => {
  const { data } = await HttpHandler({
    method: 'GET',
    url: `${environment.DOCUMENTS_APP_URL}/documents/pdf/client/clients-contracts/json-tree/${specialistId}/${lang}`,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return data.data;
};

export const getUrlSpecialistContractPdfById = async (id: string, specialistId: string, lang: string) => {
  try {
    const { data: contractTokenData } = await HttpHandler({
      method: 'GET',
      url: `${environment.DOCUMENTS_APP_URL}/documents/pdf/client/clients-contracts/generate-contract-token/${id}/${specialistId}/${lang}`,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const { data } = contractTokenData;

    return `${environment.DOCUMENTS_APP_URL}/documents/pdf/common/clients-contracts/by-token/${data}/`;
  } catch (error) {
    throw error;
  }
};
